import { render } from "./DeleteUserGuideDialog.vue?vue&type=template&id=544b0448"
import script from "./DeleteUserGuideDialog.vue?vue&type=script&lang=js"
export * from "./DeleteUserGuideDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__